export const TYPES = {
  ImagesService: Symbol.for('Images/ImagesService'),
  IImagesConfigProvider: Symbol.for('Images/IImagesConfigProvider'),
  IRequestSliceStrategiesProvider: Symbol.for('Images/IRequestSliceStrategiesProvider'),
  ImagesModeController: Symbol.for('Images/ImagesModeController'),
  ImageScrollStrategiesFactory: Symbol.for('Images/ImageScrollStrategiesFactory'),
};
